module.exports = __webpack_public_path__ + "static/media/mobile-image.ceda14d6.png";